import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { getLiteral } from '../modules/util.js';

/*********************
*** TEMPLATES FILE ***
**********************/	
let mainTemplate;
let layerGroupTemplate;
let polygonGroupTemplate;
let filtroTaxonesTemplate;
let taxonesSubheadingTemplate;
let sugeTaxonesTemplate;
let taxonesBlockTemplate;
let taxonModalTemplate;
let filterPlotModalTemplate;
let footerFilterPlot;
let divManBloq;
let divRegs;
let divPolis;
let buscarTemplate;
let sugeLugaresTemplate;
let plotPopupTemplate;
let regPopupTemplate;
let poliPopupTemplate;
let uploadPolygonTemplate;
let downloadTemplateBody;
let downloadingTemplateBody;
let footerDescargaDatos;
let footerDescargando;
let footerDescargaDatosExito;
let alertQuestionnaireTemplate;

let urlImagesLayers = [
	new URL('../images/default.png', import.meta.url),
	new URL('../images/satellite.png', import.meta.url),
	new URL('../images/munis.png', import.meta.url),
	new URL('../images/regions.png', import.meta.url)
];

function updateHTMLtemplates() {
	mainTemplate = 
'<div class="row justify-content-lg-center m-1 m-md-2 p-0"> \
	<div class="col-lg-10 p-0"> \
		<div class="card text-center p-0"> \
			<div class="card-header py-0 px-1 px-md-3"> \
				<div class="d-flex justify-content-between"> \
					<div class="dropdown"> \
						<button id ="bot_inicio" class="btn btn-outline-secondary mt-1 py-1" type="button" title="'+getLiteral(dict.menu)+'" \
							data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-list"></i> \
						</button> \
						<ul class="dropdown-menu"> \
							<li><a class="dropdown-item home" href="#">'+getLiteral(dict.home)+'</a></li> \
							<li><hr class="dropdown-divider"></li> \
							<li><a class="dropdown-item lang" tag="en" href="#">🇬🇧 EN</a></li> \
							<li><a class="dropdown-item lang" tag="es" href="#">🇪🇸 ES</a></li> \
						</ul> \
					</div> \
					<!--div class="btn-group langradio py-1" role="group" aria-label="'+getLiteral(dict.language)+'" title="'+getLiteral(dict.language)+'"> \
						<input type="radio" class="btn-check" name="langradio" id="en" autocomplete="off"> \
						<label class="btn btn-outline-secondary px-2 py-1 my-0" for="en">🇬🇧</label> \
						<input type="radio" class="btn-check" name="langradio" id="es" autocomplete="off"> \
						<label class="btn btn-outline-secondary px-2 py-1 my-0" for="es">🇪🇸</label> \
					</div--> \
					<div class="text mt-2"><h5 id="titulo">'+getLiteral(dict.title)+'</h5></div> \
					<div class="btn-group ifnradio ms-1 my-0 py-1" role="group" aria-label="'+getLiteral(dict.ifnversion)+'" title="'+getLiteral(dict.ifnversion)+'"> \
						<input type="radio" class="btn-check" name="ifnradio" id="ifn2" autocomplete="off"> \
						<label id="label-ifn2" class="btn btn-outline-secondary px-1 px-md-2 py-1 my-0" for="ifn2">'+getLiteral(dict.IFN2)+'</label> \
						<input type="radio" class="btn-check" name="ifnradio" id="ifn3" autocomplete="off"> \
						<label id="label-ifn3" class="btn btn-outline-secondary px-1 px-md-2 py-1 my-0" for="ifn3">'+getLiteral(dict.IFN3)+'</label> \
						<input type="radio" class="btn-check" name="ifnradio" id="ifn4" autocomplete="off" disabled> \
						<label id="label-ifn4" class="btn btn-outline-secondary px-1 px-md-2 py-1 my-0" for="ifn4">'+getLiteral(dict.IFN4)+'</label> \
					</div> \
				</div> \
			</div> \
			<div class="card-body p-0"> \
				<div id="mimapa" style="height: 60vh;"> \
					<div id="mapoverlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 999;"> \
						<div class="d-flex justify-content-center align-items-center overlay-backdrop" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2);"> \
							<div class="spinner-border" role="status"> \
								<span class="visually-hidden">Loading...</span> \
							</div> \
						</div> \
					</div> \
				</div> \
				<ul class="list-group list-group-flush mt-0"> \
					<li id="li-barra" class="list-group-item text-center mt-0"> \
						<div class="row px-1 px-md-2"> \
							<div id="mapclue" class="col-sm-5 text-center"><i>'+getLiteral(dict.starting)+'</i></div> \
							<div id="mibarradiv" class="col-sm-7 progress mt-1 mx-0 mb-0 p-0" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"> \
						        <div id="mibarra" class="progress-bar progress-bar-striped progress-bar-animated bg-secondary" style="width: 0%" >0%</div> \
						    </div> \
					    </div> \
					</li> \
					<li id="li-man-bloq" class="list-group-item d-flex justify-content-evenly px-1 px-md-3 d-none"></li> \
					<li id="li-regs" class="list-group-item text-center pb-0 px-1 px-md-3 d-none"></li> \
					<li id="li-polis" class="list-group-item text-center pb-0 px-1 px-md-3 d-none"></li> \
					<li id="li-taxons" class="list-group-item px-1 px-md-3 py-1"> \
						<div id="div-taxons-heading" class="d-flex justify-content-center flex-wrap"> \
							<div class="btn-group my-1"> \
								<button id="bot_taxones" class="text-nowrap btn btn-outline-secondary" type="button" disabled> \
									'+getLiteral(dict.taxonfilter)+'</button> \
								<input id="checknomci" type="checkbox" class="btn-check" id="btn-check" autocomplete="off" {{#nomci}}checked{{/nomci}} > \
								<label id="labchecknomci" title="'+getLiteral(dict.nomci)+'" class="btn btn-outline-secondary px-2" for="checknomci"> \
									<i class="bi bi-mortarboard-fill"></i> \
								</label> \
							</div> \
							<div id="plantae" class="input-group w-auto ms-2 my-1 d-none"> \
								<span id="lab_plantae" class="input-group-text border border-secondary px-1 px-md-2" \
									style="background-color: '+ config.colores[0][1] +';"><i>Plantae</i> \
								</span> \
								<button id="filter-plantae" class="btn btn-outline-secondary px-2" type="button" turi="'+ config.treeUri +'"> \
									<i class="bi bi-filter-circle"></i> \
								</button> \
								<button class="btn btn-outline-secondary px-2 info_taxon" type="button" turi="' + config.txPlantae + '" > \
									<i class="bi bi-info-circle-fill"></i> \
								</button> \
							</div> \
						</div> <!-- div-taxons-heading --> \
						<div class="d-flex justify-content-center"> \
							<div id="taxones_subheading" class="col-12 col-md-10 col-lg-9 col-xl-7"></div> \
						</div> \
						<div class="d-flex justify-content-center"> \
							<div id="taxones_block" class="list-group col-12 col-md-10 col-lg-9 col-xl-7 \
								text-start overflow-auto mt-1 mb-3 d-none" style="max-height:50vh;"></div> \
						</div> \
						<div id="taxones_resumen" class="d-flex justify-content-center align-items-center my-1 d-none"> \
							<div id="radioandor" class="btn-group" role="group" aria-label="AND-OR"> \
								<input type="radio" class="btn-check" name="btnradioandor" id="and" autocomplete="off"> \
								<label class="btn btn-outline-secondary px-2 py-1 my-0" for="and">AND</label> \
								<input type="radio" class="btn-check" name="btnradioandor" id="or" autocomplete="off"> \
								<label class="btn btn-outline-secondary px-2 py-1 my-0" for="or">OR</label> \
							</div> \
							<h6 id="textfiltered" class="card-subtitle text-body-secondary ms-2 ms-md-3"></h6> \
						</div> \
					</li> \
				</ul> \
			</div> \
		</div><!-- card --> \
	</div> \
</div> \
<footer class="container my-3"> \
	<h5 class="card-subtitle text-body-primary text-center"> \
		<span id="nplotsselected">#'+getLiteral(dict.plotsSelected)+':</span> <strong id="numplots">0</strong> \
		<button id="botdescargar" type="button" class="ms-3 ms-md-5 mt-2 mt-md-0 mb-2 btn btn-primary">'+getLiteral(dict.download)+'</button> \
	</h5> \
</footer>';


	layerGroupTemplate =
	'<div class="collapse card p-0" id="sel-layers"> \
		<div class="card-body p-1"> \
			<div class="row g-0"> \
				<div class="col-6 text-center"> \
					<h6 class="card-title m-1">' + getLiteral(dict.mapType) + '</h6> \
				</div> \
				<div class="col-6 text-center"> \
					<h6 class="card-title m-1">' + getLiteral(dict.mapDetails) + '</h6> \
				</div> \
			</div> \
			<div class="row input-group text-center justify-content-center g-0"> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapType" id="map-type-default" value="default"> \
					<label class="btn" for="map-type-default"> \
						<img src="'+urlImagesLayers[0]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.default) + '</div> \
				</div> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapType" id="map-type-satellite" value="satellite"> \
					<label class="btn" for="map-type-satellite"> \
						<img src="'+urlImagesLayers[1]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.satellite) + '</div> \
				</div> \
				<div class="col-auto px-1 px-sm-2"> \
					<div class="vertical-line"></div> \
				</div> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-munis" value="munis"> \
					<label class="btn" for="map-details-munis"> \
						<img src="'+urlImagesLayers[2]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.municipalities) + '</div> \
				</div> \
				<div class="col form-check px-1 px-sm-2"> \
					<input class="btn-check micheckmapa" type="radio" name="mapDetails" id="map-details-provs" value="provs"> \
					<label class="btn" for="map-details-provs"> \
						<img src="'+urlImagesLayers[3]+'" class="img-fluid rounded" alt="..."> \
					</label> \
					<div class="text-nowrap">' + getLiteral(dict.provinces) + '</div> \
				</div> \
			</div> \
		</div> \
	</div> \
	<div class="group mt-auto ms-auto" style="border: 2px solid #0003; border-radius: 4px;"> \
		<a class="layer" title="' + getLiteral(dict.selectLayer) + '" href="#sel-layers" role="button" \
				data-bs-toggle="collapse" aria-expanded="false" aria-controls="sel-layers"> \
			<span class="bi bi-layers-fill"></span> \
		</a> \
	</div>';
	
	
	polygonGroupTemplate =
	'<div class="collapse p-0" id="sel-polygon"> \
		<div class="btn-group" role="group" aria-label="sel-polygon"> \
			<button id="drawpoli" type="button" class="btn btn-secondary"> \
				<i class="bi bi-pencil-fill"></i> ' + getLiteral(dict.draw) + '</button> \
			<button id="uploadpoli" type="button" class="btn btn-secondary"> \
				<i class="bi bi-file-earmark-arrow-up-fill"></i> ' + getLiteral(dict.upload) + '</button> \
		</div> \
	</div> \
	<div class="group mt-auto ms-auto" style="border: 2px solid #0003; border-radius: 4px;"> \
		<a class="collpoli" title="' + getLiteral(dict.createPolygon) + '" href="#sel-polygon" role="button" \
				data-bs-toggle="collapse" aria-expanded="false" aria-controls="sel-polygon"> \
			<span class="bi bi-pentagon-fill"></span> \
		</a> \
	</div>';
	
	
	filtroTaxonesTemplate =	
	'{{#.}} \
		<div class="input-group w-auto ms-2 my-1 div_filtro_taxon"> \
			<span class="input-group-text border border-secondary px-1 px-md-2" style="background-color: {{color}};"> \
				{{{textoFiltroTaxon}}}</span> \
			<button class="btn btn-outline-secondary px-2 tune_filter_taxon" type="button" turi="{{{turi}}}" > \
				<i class="bi bi-filter-circle{{#filterUnset}}-fill{{/filterUnset}}"></i> \
			</button> \
			<button class="btn btn-outline-secondary px-2 info_taxon {{^info}}d-none{{/info}}" type="button" turi="{{{turi}}}" > \
				<i class="bi bi-info-circle-fill"></i> \
			</button> \
			<button class="btn btn-outline-secondary px-2 color_filtro" type="button" data-bs-toggle="dropdown" aria-expanded="false"> \
				<i class="bi bi-droplet-fill"></i> \
			</button> \
			<ul id="ul_colores{{ind}}" class="dropdown-menu" aria-labelledby="dropdownMenu"> \
				{{#colores}} \
					<li><a class="dropdown-item color_taxon" href="#" ind="{{ind}}" cind="{{cind}}">{{label}}</a></li> \
				{{/colores}} \
			</ul> \
			<button class="btn btn-outline-secondary px-2 quitar_taxon" type="button" ind="{{ind}}" > \
				<i class="bi bi-x-lg"></i> \
			</button> \
		</div> \
	{{/.}}';

	taxonesSubheadingTemplate = 
	'{{#activar}} \
		<input id="in_taxon" autocomplete="off" type="search" class="form-control my-1" \
			 placeholder="'+getLiteral(dict.searchtaxon)+'" aria-label="'+getLiteral(dict.searchtaxon)+'"> \
	{{/activar}} \
	<div id="sugetaxones" class="list-group text-start mb-3 d-none"></div>';

	sugeTaxonesTemplate = 
	'{{#sugerencias}} \
		<button class="list-group-item list-group-item-action bot_suge_taxon" type="button" spuri="{{uri}}"> \
			{{#nc}}<i>{{/nc}}{{{labelshown}}}{{#nc}}</i>{{/nc}}<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nplotslab}} P</span> \
		</button> \
	{{/sugerencias}} \
	{{#nosugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_taxon" disabled>'+getLiteral(dict.notaxonfound)+'</button> \
	{{/nosugerencias}}';
	
	taxonesBlockTemplate = 
	'{{#.}} \
		<div class="{{^esconder}}d-flex {{/esconder}}bd-highlight border-bottom border-left border-right taxon {{#esconder}}d-none{{/esconder}}" indice="{{indice}}"> \
			{{#botonesconder}} \
				<div><span>{{{indentspace}}}</span><span><button type="button" class="btn btn-outline-secondary btn-sm showmore">'+getLiteral(dict.showmore)+'</button></span></div> \
			{{/botonesconder}} \
			{{^botonesconder}} \
				<div class="flex-grow-1"> \
					<button class="list-group-item list-group-item-action border-0 bot_sel_taxon" type="button" spuri="{{uri}}"> \
						{{{indentspace}}}{{#nc}}<i>{{/nc}}{{label}}{{#nc}}</i>{{/nc}} \
						<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nplotslab}} P</span> \
					</button> \
				</div> \
				<div class="p-1"> \
					<button class="btn btn-outline-secondary btn-sm bot_expandir_taxon {{#nosubclasses}}invisible{{/nosubclasses}}" \
						type="button" data-placement="top"><i class="bi bi-chevron-right"></i> \
					</button> \
				</div> \
			{{/botonesconder}} \
		</div> \
	{{/.}}';
	
	
	taxonModalTemplate =
	'<div class="container-fluid"> \
		{{#hayimagen}} \
			<div class="row"> \
				<div class="col-sm-5"> \
		{{/hayimagen}} \
					<h5 class="text-muted">{{tipo}}</h5> \
		{{#hayimagen}} \
			{{^multimages}} \
					<img class="img-fluid mt-1 mb-2" src="{{{image}}}"> \
			{{/multimages}} \
			{{#multimages}} \
				<div id="carouselPopupTaxon" class="carousel slide" data-bs-ride="carousel"> \
					<div class="carousel-inner"> \
						{{#image}} \
							<div class="carousel-item {{#active}}active{{/active}}"> \
								<img src="{{{src}}}" > \
							</div> \
						{{/image}} \
					</div> \
					<button class="carousel-control-prev" type="button" data-bs-target="#carouselPopupTaxon" data-bs-slide="prev"> \
						<span class="carousel-control-prev-icon" aria-hidden="true"></span> \
						<span class="visually-hidden">Previous</span> \
					</button> \
					<button class="carousel-control-next" type="button" data-bs-target="#carouselPopupTaxon" data-bs-slide="next"> \
						<span class="carousel-control-next-icon" aria-hidden="true"></span> \
						<span class="visually-hidden">Next</span> \
					</button>   \
				</div> \
			{{/multimages}} \
				</div> \
				<div class="col-sm-7"> \
		{{/hayimagen}} \
					{{#resumen}} \
						<p>{{resumen}}</p> \
					{{/resumen}} \
					{{#gbifPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm mb-1">GBIF</a> \
					{{/gbifPage}} \
					{{#wikidataPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm mb-1">Wikidata</a> \
					{{/wikidataPage}} \
					{{#wikipediaPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm mb-1">Wikipedia</a> \
					{{/wikipediaPage}} \
					{{#wikispeciesPage}} \
						<a href="{{{.}}}" target="_blank" \
							class="btn btn-secondary btn-sm mb-1">WikiSpecies</a> \
					{{/wikispeciesPage}} \
		{{#hayimagen}} \
				</div> \
			</div> \
		{{/hayimagen}} \
	</div>';
	
	
	filterPlotModalTemplate = 
	'<div class="container-fluid"> \
		<h5>{{{txname}}}</h5> \
		<div class="input-group mt-1"> \
			<input id="nt-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.nt+'" min="0" value="{{ntmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">{{{numbertreesHA}}}</span> \
			<input id="nt-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.nt+'" min="0" value="{{ntmax}}"> \
		</div> \
		<div id="nt" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="ba-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.ba+'" min="0" value="{{bamin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">{{{basalareaHA}}}</span> \
			<input id="ba-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.ba+'" min="0" value="{{bamax}}"> \
		</div> \
		<div id="ba" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="vwb-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwb+'" min="0" value="{{vwbmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">{{{volumewithbarkHA}}}</span> \
			<input id="vwb-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwb+'" min="0" value="{{vwbmax}}"> \
		</div> \
		<div id="vwb" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="vwob-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwob+'" min="0" value="{{vwobmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">{{{volumewithoutbarkHA}}}</span> \
			<input id="vwob-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwob+'" min="0" value="{{vwobmax}}"> \
		</div> \
		<div id="vwob" class="uislider mt-1"></div> \
	</div>';/*
	'<div class="container-fluid"> \
		<h5>{{{txname}}}</h5> \
		<div class="input-group mt-1"> \
			<input id="nt-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.nt+'" min="0" value="{{ntmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">'+getLiteral(dict.numbertreesHA)+'</span> \
			<input id="nt-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.nt+'" min="0" value="{{ntmax}}"> \
		</div> \
		<div id="nt" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="ba-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.ba+'" min="0" value="{{bamin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">'+getLiteral(dict.basalareaHA)+'</span> \
			<input id="ba-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.ba+'" min="0" value="{{bamax}}"> \
		</div> \
		<div id="ba" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="vwb-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwb+'" min="0" value="{{vwbmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">'+getLiteral(dict.volumewithbarkHA)+'</span> \
			<input id="vwb-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwb+'" min="0" value="{{vwbmax}}"> \
		</div> \
		<div id="vwb" class="uislider mt-1"></div> \
		<div class="input-group mt-4"> \
			<input id="vwob-min" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwob+'" min="0" value="{{vwobmin}}"> \
			<span class="input-group-text w-50 d-flex justify-content-center">'+getLiteral(dict.volumewithoutbarkHA)+'</span> \
			<input id="vwob-max" type="number" class="form-control w-25" max="'+config.maxValuesPlot.vwob+'" min="0" value="{{vwobmax}}"> \
		</div> \
		<div id="vwob" class="uislider mt-1"></div> \
	</div>';*/	
	footerFilterPlot = 
	'<button id="resetFilter" type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal">'+getLiteral(dict.resetfilter)+'</button> \
		<button id="applyFilter" type="button" class="ms-auto btn btn-primary" \
			data-bs-dismiss="modal" aria-label="Apply filter">'+getLiteral(dict.applyfilter)+'</button>';
	/*
	filterPlotModalTemplate = 
	'<div class="container-fluid"> \
		<h5>{{{txname}}}</h5> \
		<div class="d-flex justify-content-between"> \
			<span>'+getLiteral(dict.numbertreesHA)+'</span> \
			<span id="nt-range"></span> \
		</div> \
		<div id="nt" class="uislider mt-2"></div> \
		<div class="d-flex justify-content-between mt-3"> \
			<span>'+getLiteral(dict.basalareaHA)+'</span> \
			<span id="ba-range"></span> \
		</div> \
		<div id="ba" class="uislider mt-2"></div> \
		<div class="d-flex justify-content-between mt-3"> \
			<span>'+getLiteral(dict.volumewithbarkHA)+'</span> \
			<span id="vwb-range"></span> \
		</div> \
		<div id="vwb" class="uislider mt-2"></div> \
		<div class="d-flex justify-content-between mt-3"> \
			<span>'+getLiteral(dict.volumewithoutbarkHA)+'</span> \
			<span id="vwob-range"></span> \
		</div> \
		<div id="vwob" class="uislider mt-2"></div> \
	</div>';
	footerFilterPlot =
	'<button id="applyFilter" type="button" class="btn btn-primary" \
			data-bs-dismiss="modal" aria-label="Apply filter">'+getLiteral(dict.applyfilter)+'</button>';
	*/
	
	
	divManBloq =
'{{#man}} \
	<div class="btn-group" role="group" aria-label="manual"> \
		<button id="bot-manual-focus" type="button" class="btn btn-warning border border-dark px-1 px-md-2">'+getLiteral(dict.bmanual)+' <span class="badge text-bg-secondary">{{nman}}</span></button> \
		<button id="bot-manual-borrar" type="button" class="btn btn-outline-secondary px-2"><i class="bi bi-x-lg"></i></button> \
	</div> \
{{/man}} \
{{#bloq}}\
	<div class="btn-group" role="group" aria-label="blocked"> \
		<button id="bot-blocked-focus" type="button" class="btn btn-dark px-1 px-md-2">'+getLiteral(dict.bblocked)+' <span class="badge text-bg-secondary">{{nbloq}}</span></button> \
		<button id="bot-blocked-borrar" type="button" class="btn btn-outline-secondary px-2"><i class="bi bi-x-lg"></i></button> \
	</div> \
{{/bloq}}';

/*
'{{#man}}<button id="bot-manual" type="button" class="btn btn-warning"><i class="bi bi-x-lg"></i> Manual <span class="badge text-bg-secondary">{{nman}}</span></button>{{/man}} \
{{#bloq}}<button id="bot-blocked" type="button" class="btn btn-dark"><i class="bi bi-x-lg"></i> '+getLiteral(dict.blocked)+' <span class="badge text-bg-secondary">{{nbloq}}</span></button>{{/bloq}}';
*/

	divRegs = 
//'<h6 class="card-subtitle text-body-secondary mb-1">'+getLiteral(dict.provinces)+'</h6> \
'{{#.}} \
	<div class="btn-group mb-2 me-1" role="group" aria-label="{{name}}"> \
		<button iri="{{{iri}}}" type="button" class="btn btn-warning border border-dark focus px-1 px-md-2">{{name}} <span class="badge text-bg-secondary">{{cant}}</span></button> \
		<button iri="{{{iri}}}" type="button" class="btn btn-outline-secondary borrar px-2"><i class="bi bi-x-lg"></i></button> \
	</div> \
{{/.}}';

/*
getLiteral(dict.provinces)+': \
{{#.}} \
	<div class="btn-group mb-2" role="group" aria-label="{{name}}"> \
		<button iri="{{{iri}}}" type="button" class="btn btn-secondary borrar px-2"><i class="bi bi-x-lg"></i></button> \
		<button iri="{{{iri}}}" type="button" class="btn btn-warning focus px-1 px-md-2">{{name}} <span class="badge text-bg-secondary">{{cant}}</span></button> \
	</div> \
{{/.}}';*/
/*getLiteral(dict.provinces)+': \
{{#.}} \
	<button id="{{{iri}}}" type="button" class="mb-2 btn btn-warning"><i class="bi bi-x-lg"></i> {{name}} <span class="badge text-bg-secondary">{{cant}}</span></button> \
{{/.}}';*/

	divPolis = 
//getLiteral(dict.polygons)+': \
//'<h6 class="card-subtitle text-body-secondary mb-1">'+getLiteral(dict.polygons)+'</h6> \
'{{#.}} \
	<div class="btn-group mb-2 me-1" role="group" aria-label="poli{{ind}}"> \
		<button id="poli{{ind}}-focus" type="button" class="btn btn-warning border border-dark px-1 px-md-2">'+getLiteral(dict.polygon)+' #{{ind}} <span class="badge text-bg-secondary">{{cant}}</span></button> \
		<button id="poli{{ind}}-borrar" type="button" class="btn btn-outline-secondary px-2"><i class="bi bi-x-lg"></i></button> \
	</div> \
{{/.}}';
/*
getLiteral(dict.polygons)+': \
{{#.}} \
	<button id="poli{{ind}}" type="button" class="mb-2 btn btn-warning"><i class="bi bi-x-lg"></i> '+getLiteral(dict.polygon)+' #{{ind}} <span class="badge text-bg-secondary">{{cant}}</span></button> \
{{/.}}';*/

	buscarTemplate = 
	'<div class="collapse card p-0" id="buscar_lugares"> \
		<div class="card-body p-0"> \
			<div class="row g-0"> \
				<div id="lugares_heading" class="list-group"> \
					<input id="in_lugares" autocomplete="off" type="search" class="form-control " \
						placeholder="'+getLiteral(dict.searchplace)+'" aria-label="'+getLiteral(dict.searchplace)+'"> \
				</div> \
			</div> \
			<div id="sugelugares" class="text-start list-group mt-1 d-none"></div> \
		</div> \
	</div> \
	<div class="group mt-0 ms-auto"> \
		<a class="buscar_lugares" title="' + getLiteral(dict.searchplace) + '" href="#buscar_lugares" role="button" \
				data-bs-toggle="collapse" aria-expanded="false" aria-controls="buscar_lugares"> \
			<span class="bi bi-search"></span> \
		</a> \
	</div>';
	
	sugeLugaresTemplate = 
	'{{#sugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_lugar" id="{{id}}">{{{name}}}</button> \
	{{/sugerencias}} \
	{{#nosugerencias}} \
		<button type="button" class="list-group-item list-group-item-action py-2" disabled>'+getLiteral(dict.noplacesfound)+'</button> \
	{{/nosugerencias}}';
	
	
	plotPopupTemplate =
	'<div iri="{{{iri}}}" class="{{#chart}}row{{/chart}}{{^chart}}text-center{{/chart}} m-0 p-0 popup parcela"> \
		{{#chart}} \
		<div class="col-6 text-center d-flex align-items-center justify-content-center flex-column m-0 p-0"> \
		{{/chart}} \
			<strong>{{plot}}</strong> \
			{{^chart}}<br>{{/chart}}<span class="fw-light">{{{source}}}</span> \
			{{#dataCapture}} \
				{{^chart}}<br>{{/chart}}<span class="fw-light">{{dataCapture}}</span> \
			{{/dataCapture}} \
			<p class="fw-medium {{#notrees}}text-danger{{/notrees}} my-2">{{{stockinfo}}}</p> \
			{{#status}} \
				<p class="{{statusClass}} mt-0 mb-2">{{status}}</p> \
			{{/status}} \
			{{#manual}} \
				<button iri="{{{iri}}}" class="btn btn-warning border border-dark plotpopup" type="button">'+getLiteral(dict.select)+'</button> \
			{{/manual}} \
			{{#bloq}} \
				<button iri="{{{iri}}}" class="btn btn-dark plotpopup" type="button">'+getLiteral(dict.block)+'</button> \
			{{/bloq}} \
			{{#unbloq}} \
				<button iri="{{{iri}}}" class="btn btn-outline-secondary plotpopup" type="button">'+getLiteral(dict.unblock)+'</button> \
			{{/unbloq}} \
		{{#chart}} \
		</div> \
		<div class="col-6 text-center d-flex align-items-center justify-content-center flex-column m-0 p-0"> \
			<button id="botonInfoSpeciesStock" class="btn btn-sm btn-secondary dropdown-toggle" type="button" \
				data-bs-toggle="dropdown" aria-expanded="false">'+getLiteral(dict.treedensity)+'</button> \
			<ul class="dropdown-menu"> \
				<li><a class="dropdown-item isstock" ind="0" href="#">'+getLiteral(dict.treedensity)+'</a></li> \
				<li><a class="dropdown-item isstock" ind="1" href="#">'+getLiteral(dict.basalarea)+'</a></li> \
				<li><a class="dropdown-item isstock" ind="2" href="#">'+getLiteral(dict.volumewithbark)+'</a></li> \
				<li><a class="dropdown-item isstock" ind="3" href="#">'+getLiteral(dict.volumewithoutbark)+'</a></li> \
			</ul> \
			<canvas class="d-none"></canvas> \
			<!--p class="text-center my-0">'+getLiteral(dict.treesperha)+'</p!--> \
		</div> \
		{{/chart}} \
	</div>';
	
	/*
	provPopupTemplate =
	'<div iri="{{{iri}}}" class="{{#chart}}row{{/chart}}{{^chart}}text-center{{/chart}} m-0 p-0 popup prov"> \
		{{#chart}} \
		<div class="col-4 text-center d-flex align-items-center justify-content-center flex-column m-0 p-0"> \
		{{/chart}} \
			<strong>{{prov}}</strong> \
			<br><span class="fw-light">{{{source}}}</span> \
			{{#dataCapture}} \
				<br><span class="fw-light">{{dataCapture}}</span> \
			{{/dataCapture}} \
			<p class="fw-medium my-2">{{sampledplots}}</p> \
			<p class="{{statusClass}} mt-0 mb-1">{{status}}</p> \
			{{#selected}} \
				<button iri="{{{iri}}}" class="btn btn-outline-secondary provpopup" type="button">'+getLiteral(dict.unselect)+'</button> \
			{{/selected}} \
			{{#unselected}} \
				<button iri="{{{iri}}}" class="btn btn-warning border border-dark provpopup" type="button">'+getLiteral(dict.select)+'</button> \
			{{/unselected}} \
		{{#chart}} \
		</div> \
		<div class="col-8 text-center d-flex align-items-center justify-content-center flex-column m-0 p-0"> \
			<canvas class="d-none"></canvas> \
			<p class="text-center my-0">'+getLiteral(dict.nplots)+'</p> \
		</div> \
		{{/chart}} \
	</div>';*/
	regPopupTemplate =
	'<div iri="{{{iri}}}" class="{{#chart}}row{{/chart}}{{^chart}}text-center{{/chart}} m-0 p-0 popup reg"> \
		{{#chart}} \
		<div class="col-5 text-center d-flex align-items-center justify-content-center flex-column m-0 p-0"> \
		{{/chart}} \
			<strong>{{reg}}</strong> \
			{{#infoprov}} \
				{{^chart}}<br>{{/chart}}<span>{{infoprov}}</span> \
			{{/infoprov}} \
			{{^chart}}<br>{{/chart}}<span class="fw-light">{{{source}}}</span> \
			{{#dataCapture}} \
				{{^chart}}<br>{{/chart}}<span class="fw-light">{{dataCapture}}</span> \
			{{/dataCapture}} \
			{{#noplots}} \
				<p class="fw-medium my-2 text-danger">'+getLiteral(dict.nosampledplots)+'</p> \
			{{/noplots}} \
			{{^noplots}} \
				<p class="fw-medium my-2">{{sampledplots}}</p> \
			{{/noplots}} \
			<p class="{{statusClass}} mt-0 mb-2">{{status}}</p> \
			{{#selected}} \
				<button iri="{{{iri}}}" class="btn btn-outline-secondary regpopup" type="button">'+getLiteral(dict.unselect)+'</button> \
			{{/selected}} \
			{{#unselected}} \
				<button iri="{{{iri}}}" class="btn btn-warning border border-dark regpopup" type="button">'+getLiteral(dict.select)+'</button> \
			{{/unselected}} \
		{{#chart}} \
		</div> \
		<div class="col-7 text-center d-flex align-items-center justify-content-center flex-column m-0 p-0"> \
			<canvas class="d-none"></canvas> \
			<p class="text-center my-0">'+getLiteral(dict.nplots)+'</p> \
		</div> \
		{{/chart}} \
	</div>';
	
	
	poliPopupTemplate =
	'<div iri="{{{iri}}}" class="{{#chart}}row{{/chart}}{{^chart}}text-center{{/chart}} m-0 p-0 popup poli"> \
		{{#chart}} \
		<div class="col-4 text-center d-flex align-items-center justify-content-center flex-column m-0 p-0"> \
		{{/chart}} \
			<strong>{{poli}}</strong> \
			<span class="fw-light">{{{source}}}</span> \
			<p class="fw-medium my-2">{{sampledplots}}</p> \
			<p class="{{statusClass}} mt-0 mb-2">{{status}}</p> \
			<button iri="{{{iri}}}" class="btn btn-dark polipopup" type="button">'+getLiteral(dict.delete)+'</button> \
		{{#chart}} \
		</div> \
		<div class="col-8 text-center d-flex align-items-center justify-content-center flex-column m-0 p-0"> \
			<canvas class="d-none"></canvas> \
			<p class="text-center my-0">'+getLiteral(dict.nplots)+'</p> \
		</div> \
		{{/chart}} \
	</div>';
	
	
	
	uploadPolygonTemplate = 
	'<p>'+getLiteral(dict.uploadText)+'</p> \
	<div class="input-group"> \
		<input id="inputUploadFile" type="file" class="form-control" accept=".shp, .json, .geojson, .txt, .wkt"> \
	</div> \
	<br><div id="wgs84alert" class="alert alert-warning py-1" role="alert">'+getLiteral(dict.wgs84Text)+'</div> \
	<div id="uploadalert" class="alert alert-danger py-1 d-none" role="alert"></div>';
	
	
	
	downloadTemplateBody =
	'<div> \
		<p>'+getLiteral(dict.downloadMessage)+'</p> \
		<div>'+getLiteral(dict.downloadIFN)+'</div> \
		<div class="btn-group" role="group" aria-label="Download IFN"> \
			<input class="btn-check check-ifn" type="checkbox" value="" id="checkIFN2" {{#ifn2}}checked{{/ifn2}}> \
			<label class="btn btn-outline-primary" for="checkIFN2">'+getLiteral(dict.IFN2)+'</label> \
			<input class="btn-check check-ifn" type="checkbox" value="" id="checkIFN3" {{#ifn3}}checked{{/ifn3}}> \
			<label class="btn btn-outline-primary" for="checkIFN3">'+getLiteral(dict.IFN3)+'</label> \
		</div> \
		<br><div id="downloadNoIFN" class="d-none"><strong>'+getLiteral(dict.downloadNoIFN)+'</strong></div> \
		<br><div>'+getLiteral(dict.downloadFormatChoose)+'</div> \
		<div class="btn-group" role="group" aria-label="Download IFN"> \
			<input type="radio" class="btn-check radio-format" name="format" id="GeoJSON" autocomplete="off"> \
			<label class="btn btn-outline-primary" for="GeoJSON">GeoJSON</label> \
			<input type="radio" class="btn-check radio-format" name="format" id="CSV" autocomplete="off"> \
			<label class="btn btn-outline-primary" for="CSV">CSV</label> \
			<input type="radio" class="btn-check radio-format" name="format" id="XLSX" autocomplete="off"> \
			<label class="btn btn-outline-primary" for="XLSX">XLSX</label> \
		</div> \
		<div id="downloadNoFormat"><strong>'+getLiteral(dict.downloadNoFormat)+'</strong></div> \
	</div>';
	
	downloadingTemplateBody =
	'<div> \
		{{#ifn2}} \
		<div id="downloadingPlotsifn2" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.downloading) + ' ' + '{{plotsifn2}} ' 
				+ getLiteral(dict.plotsIFN2) + '...</span> \
		</div> \
		<div id="plotsDownloadedifn2" class="d-none"><i class="bi bi-check-lg"></i> \
			<span class="ms-1">{{plotsifn2}} ' + getLiteral(dict.plotsIFN2) + ' '+ getLiteral(dict.downloaded) +'</span> \
		</div> \
		<div id="noPlotsDownloadedifn2" class="d-none"><i class="bi bi-info-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.noPlotsDownloadedIFN2) +'</span> \
		</div> \
		{{/ifn2}} \
		{{#ifn3}} \
		<div id="downloadingPlotsifn3" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.downloading) + ' ' + '{{plotsifn3}} ' 
				+ getLiteral(dict.plotsIFN3) + '...</span> \
		</div> \
		<div id="plotsDownloadedifn3" class="d-none"><i class="bi bi-check-lg"></i> \
			<span class="ms-1">{{plotsifn3}} ' + getLiteral(dict.plotsIFN3) + ' '+ getLiteral(dict.downloaded) +'</span> \
		</div> \
		<div id="noPlotsDownloadedifn3" class="d-none"><i class="bi bi-info-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.noPlotsDownloadedIFN3) +'</span> \
		</div> \
		{{/ifn3}} \
		<div id="mibarradescarga_div" class="progress mt-2" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"> \
			<div id="mibarradescarga" class="progress-bar progress-bar-striped progress-bar-animated bg-primary" style="width: 0%" >0%</div> \
		</div> \
		<div id="preparingFiles" class="d-none"><i class="bi bi-arrow-right-circle"></i> \
			<span class="ms-1">'+ getLiteral(dict.preparingFiles) + '</span> \
		</div> \
		<div id="downloadSuccess" class="d-none"><br><strong>'+getLiteral(dict.downloadSuccess)+'</strong></div> \
	</div>';
	
	footerDescargaDatos = 
	'<button id="downloadCancel" type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">'+getLiteral(dict.cancel)+'</button> \
	<button id="downloadData" type="button" class="btn btn-primary" disabled>'+getLiteral(dict.download)+'</button>';
	
	footerDescargando = 
	'<button id="downloadCancel" type="button" class="btn btn-secondary" \
			data-bs-dismiss="modal" aria-label="Close">'+getLiteral(dict.cancel)+'</button>';
	
	footerDescargaDatosExito = 
	'<button id="downloadClose" type="button" class="btn btn-primary" \
			data-bs-dismiss="modal" aria-label="Close">'+getLiteral(dict.close)+'</button>';
	
	alertQuestionnaireTemplate = 
	'<div id="questalert" class="alert alert-secondary ms-2 mb-4 ms-md-4 p-2 alert-dismissible fade show text-center" role="alert"> \
		<p class="my-0"><h6>'+getLiteral(dict.questtext)+'</h6></p> \
		<button id="questbotlater" type="button" class="btn btn-secondary">'+getLiteral(dict.later)+'</button>\
		<button id="questbotno" type="button" class="btn btn-secondary mx-2">'+getLiteral(dict.no)+'</button>\
		<button id="questbotyes" type="button" questurl="'+getLiteral(dict.questurl)+'" class="btn btn-secondary">'+getLiteral(dict.yes)+'</button>\
	</div>';
}

export { mainTemplate, layerGroupTemplate, polygonGroupTemplate, filtroTaxonesTemplate, taxonesSubheadingTemplate, sugeTaxonesTemplate,
	taxonesBlockTemplate, taxonModalTemplate, filterPlotModalTemplate, footerFilterPlot, divManBloq, 
	divRegs, divPolis, buscarTemplate, sugeLugaresTemplate,
	plotPopupTemplate, regPopupTemplate, poliPopupTemplate,	uploadPolygonTemplate, downloadTemplateBody, downloadingTemplateBody, 
	footerDescargaDatos, footerDescargando, footerDescargaDatosExito, 
	alertQuestionnaireTemplate,	updateHTMLtemplates };